// @flow
import React from 'react';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import {injectIntl, type IntlShape, defineMessages} from 'react-intl';
import {compose} from 'redux';
import {connect} from 'react-redux';
import routerActions from '../../actions/router';

import './SortDropDown.less';
import {GENERIC_EVENT, trigger as edapTrigger} from '../../utils/edapWrapper';

type Props = {
    intl: IntlShape,
    filter: Function,
    orderBy: ?string,
    ascending: ?boolean
};

const messages = defineMessages({
    sort: {
        id: 'sort',
        defaultMessage: 'Sort'
    },
    default: {
        id: 'recommendedSort',
        defaultMessage: 'Recommended'
    },
    priceAscending: {
        id: 'priceAscendingSort',
        defaultMessage: 'Price: Low to High'
    },
    priceDescending: {
        id: 'priceDescendingSort',
        defaultMessage: 'Price: High to Low'
    },
    averageRating: {
        id: 'averageRatingSort',
        defaultMessage: 'Guest Rating'
    },
    demandConversion: {
        id: 'demandConversionSort',
        defaultMessage: 'Most Popular'
    },
    reviews: {
        id: 'reviewsSort',
        defaultMessage: 'Number of Reviews'
    }
});

type SortOption = {
    message: any,
    orderBy: string,
    ascending: boolean
};

const sortOptions: Array<SortOption> = [
    {
        message: messages.default,
        orderBy: 'default',
        ascending: true
    },
    {
        message: messages.priceAscending,
        orderBy: 'prices',
        ascending: true
    },
    {
        message: messages.priceDescending,
        orderBy: 'prices',
        ascending: false
    },
    {
        message: messages.averageRating,
        orderBy: 'averageRating',
        ascending: false
    },
    // SERP-1487: By command of Lord Biz this sort option is confusing and need to be disabled
    // {
    //     message: messages.demandConversion,
    //     orderBy: 'mostPopular',
    //     ascending: true
    // },
    {
        message: messages.reviews,
        orderBy: 'travelerReviewCount',
        ascending: false
    }
];

const mapStateToProps = ({searchParams: {params}}) => ({
    orderBy: params.orderBy,
    ascending: !!params.ascending
});

const mapDispatchToProps = {
    filter: routerActions.filter
};

export const SortDropDown = (props: Props) => {
    const {intl, filter} = props;
    const createHandler = (orderBy, ascending) => {
        return (e) => {
            e.preventDefault();

            edapTrigger(GENERIC_EVENT, {
                eventaction: 'sort selected'
            });

            filter({
                orderBy,
                ascending
            });
        };
    };

    const selectedIndex = Math.max(
        sortOptions.findIndex(
            (option) =>
                option.orderBy === props.orderBy &&
                option.ascending === props.ascending
        ),
        0
    );

    const displayMessage =
        selectedIndex === 0
            ? messages.sort
            : sortOptions[selectedIndex].message;

    return (
        <div className="SortDropDown">
            <Dropdown
                id="sortDropdown"
                label={intl.formatMessage(displayMessage)}
                dropdownRight
            >
                {sortOptions.map((link, index) => (
                    <DropdownItem
                        key={index}
                        text={intl.formatMessage(link.message)}
                        data-wdio={`${link.orderBy}:${String(link.ascending)}`}
                        className={
                            selectedIndex === index
                                ? 'SortDropDownItem__selected'
                                : ''
                        }
                        onClick={createHandler(link.orderBy, link.ascending)}
                        link="#"
                    />
                ))}
            </Dropdown>
        </div>
    );
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    injectIntl
)(SortDropDown);
